<template>
    <brick-settings-popup
        :resources="{
            deletePromptTitle: resource('JourneyBuilder_JourneySettings_Delete_Title'),
            deletePromptBody: resource('JourneyBuilder_JourneySettings_Delete_Body'),
            brickTitle: `${resource('JourneyComposer_BrickSettingsJourney_Title')} ${resource('JourneyComposer_BrickSettingsBase_Title')}`
        }"
        :brick="brick"
        :name.sync="newName"

        @save="saveSettings()"
        @delete="$emit('delete')"
        @hidden="$emit('hidden')"
    >
        <settings-item icon="fas fa-route" :label="resource('JourneyBuilder_Shared_Journey')">
            <template #input="{id}">
                <journey-dropdown 
                    :id="id"
                    :extra-journeys="externalJourneys"
                    :disabled="!canWrite"
                    
                    v-model="journeyIdModel"
                />
            </template>
        </settings-item>
    </brick-settings-popup>
</template>

<script>
    import api from '@modules/JourneyBuilder/api';
    import brickTypes from '@modules/JourneyBuilder/Bricks/brick-types';
    import {brickDefinitions} from "@modules/JourneyBuilder/Bricks/brick-definitions";
    import {errorGrowl} from '@core/Util/growler';
    
    import {readonlyMarkableComponentTreeMixin} from '@modules/JourneyBuilder/Mixins/journey-permissions';
    
    import BrickSettingsPopup from '../BrickSettingsPopup';
    import brickSettings from '../Mixins/brick-settings';
    import JourneyDropdown from "@modules/JourneyBuilder/Components/Elements/JourneyDropdown";
    
    export default {
        name: 'journey-brick-settings-journey',
        
        components: {
            JourneyDropdown,
            BrickSettingsPopup
        },
        
        mixins: [readonlyMarkableComponentTreeMixin, brickSettings],
        
        data() {
            return {
                journeys: []
            }
        },
        
        computed: {
            journeyIdModel: {
                get() {
                    return this.settings.journeyId;
                },
                set(value) {
                    this.settings.journeyId = value;
                }
            },
            
            externalJourneys(){
                if(!this.settings.journeyId){
                    return [];
                }

                //Temporary workaround until we implement a better solution
                //if for example our current journey becomes unavailable to moving division
                //we don't want to completely break the brick when 'edit' is clicked
                return [{
                    id: this.settings.journeyId,
                    name: this.name
                }];
            }
        },

        watch: {
            journeyIdModel(newId, oldId) {
                const defaultLabel = brickDefinitions[brickTypes.journey].displayName;

                const oldJourney = oldId && this.journeys.find(j => j.id === oldId);
                const newJourney = newId && this.journeys.find(j => j.id === newId);

                const newName = newJourney && newJourney.name;
                const oldName = oldJourney && oldJourney.name;

                //newName should change along with selected journey when name equals old journey name
                //or has not been changed (= default)
                if(this.newName === oldName || this.newName === defaultLabel){
                    this.newName = newName || defaultLabel;
                }
            }
        },
        
        async created() {
            let journeyId = this.settings.journeyId;
            
            //Child journeys are not configurable
            if(this.brick.isChildJourneyBrick) {
                this.markComponentTreeReadonly();
                
                //Override journeyId for display purposes
                journeyId = this.settings.parentJourneyId;
            }
            
            //Make journeyId reactive
            this.$set(this.settings, 'journeyId', journeyId || undefined);

            try {
                this.journeys = await api.getJourneys();
            } catch (e) {
                errorGrowl(e);
            }
        }
    };
</script>
